import React from 'react';
import { Radio, Table, Statistic, Card, Flex, Alert } from 'antd';
import { FormOutlined, AppstoreAddOutlined, TransactionOutlined } from '@ant-design/icons';
import Withdraw from '../../components/withdraw';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';
import dayjs from  'dayjs';

const cardStyle = {
    flex: 1
}

const versionMap = {
    1: '基础版',
    2: '专业版',
    3: '连锁版'
}

const statusMap = {
    0: '待结算',
    1: '结算中',
    2: '已结算',
    4: '已退款',
}

const cashoutMap = {
    'PENDING': '待结算',
    'SUCCESS': '已结算',
}

export const columns = [
    {
        title: '流水号',
        dataIndex: 'flowId',
    },
    {
        title: '渠道号',
        dataIndex: 'channelNo',
    },
    {
        title: '发生时间',
        dataIndex: 'updateTime',
        render: (text, re) => <>{dayjs(re?.pay?.updateTime || re.createTime).format('YYYY-MM-DD HH:mm:ss')}</>
    },
    {
        title: '备注',
        dataIndex: 'remark',
    },
    {
        title: '状态',
        dataIndex: 'pay_status',
        // fixed: 'right',
        render: (pay_status, record) => {
            return <>{['PENDING', 'SUCCESS'].includes(record?.status) ? cashoutMap[record?.status] : statusMap[pay_status]}</>
        }
    },
    // {
    //     title: '订单金额(元)',
    //     dataIndex: 'pay.amount',
    //     render: (text, recode) => <>{recode?.pay?.amount/100}</>
    // },
    {
        fixed: 'right',
        title: '操作人',
        dataIndex: 'operator',
    },
    {
        fixed: 'right',
        title: '金额(元)',
        dataIndex: 'amount',
        render: (text) => <>{text/100}</>
    },
    // {
    //     title: '操作',
    //     fixed: 'right',
    //     render: (text, record) => {
    //         return record?.pay?.payId ? <a href={`/pay/detail?payId=${record?.pay?.payId}`}>详情</a> : null;
    //     }
    // }
];

export default () => {
    const {versionId, wdRate, cwdRate } = window.__baseInfo;
    const [payList, setPayList] = React.useState([]);
    const [summary, setSummary] = React.useState({});
    const [shopId, setShopId] = React.useState(null);
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 10,
        total: 0,
        simple: true,
        showSizeChanger: false,
    });

    // 获取订单列表
    const getOrderList = async (params) => {
        params = params || { page : 1 , pageSize: 10};
        let urlParams = new URLSearchParams();
        const shopId = await getCurrentShopId();
        urlParams.append('shopId', shopId);

        Object.keys(params).forEach(key => {
            if(params[key]) urlParams.append(key, params[key]);
        });
        
        const response = await fetch(`/api/finance/funding-flow-invite?${urlParams.toString()}`);
        return await response.json();
    }

    const reloadData = async (params) => { 
        getOrderList(params).then(res => {
            setPayList(res?.data?.rows || []);
            setPagination({
                ...pagination, 
                current: params?.page || 1, 
                total: res?.data?.count || 0,
                pageSize: params?.pageSize || 10,
            });
        });
    }

    const loadShopSummary = async () => {
        const shopId = await getCurrentShopId();

        getShopSummary(shopId).then(res => {
            setSummary(res.data);
        });
    }

    const getShopSummary = async (shopId) => {
        const res = await fetch(`/api/finance/fund-summary-invite?shopId=${shopId}`);
        const result = await res.json();
        return result;
    }


    const onTableChange = (pagination) => {
        console.log('pagination', pagination);
        const {current, pageSize} = pagination;
        reloadData({page: current, pageSize});
        // setPagination(pagination);
    };

    React.useEffect(() => {
        reloadData();
        loadShopSummary();
    }, []);

    return (
        <>
            <SwitchShop />
            <h2>资金流水</h2>
            {/* <Months onChange={onMonthChange} /> */}
            <Flex gap={10} wrap style={{margin: '0 0 10px 0'}}>
                <Card style={cardStyle}>
                    <Statistic
                        title="余额"
                        value={summary.totalAmount/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                        // suffix="元"
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="可提现"
                        value={(summary.withdrawAmount - summary.pendingAmount + summary.pendingAmount)/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                    />
                </Card>

                <Card style={cardStyle}>
                    <Statistic
                        title="待入账"
                        value={(summary.frozenAmount)/100}
                        precision={2}
                        valueStyle={{
                            color: '#3f8600',
                        }}
                        // prefix={<ArrowUpOutlined />}
                    />
                </Card>
            </Flex>
            <Withdraw 
                style={{margin: '0 0 10px 0'}}
                maxAmount={(summary.withdrawAmount - summary.pendingAmount)/100}
                disabled={summary.withdrawAmount - summary.pendingAmount <= 0}
                type="invite"
            />
            
            <Alert
                style={{margin: '0 0 10px 0'}}
                message="账户信息"
                description={
                    <div>
                        <div>版本：{versionMap[versionId]}</div>
                        <div>提现费率：{cwdRate * 100}%(<span style={{textDecoration: 'line-through'}}>{wdRate * 100}%</span>)</div>
                        <div>提现方式：{versionId === 1 ? '手动提现': '自动提现'}</div>
                    </div>
                }
                type="info"
            />
            <Table size='small' 
                pagination={pagination} 
                rowKey={'flowId'} 
                columns={columns} 
                dataSource={payList} 
                scroll={{ x: 'max-content' }}
                onChange={onTableChange}
            />
        </>
    );
};

const Months = ({onChange}) => { 
    const [yearMonth, setYearMonth] = React.useState(undefined);
    // 当前月及之前6个月
    const months = Array.from({length: 6}, (v, k) => {
        const date = new Date();
        date.setMonth(date.getMonth() - k);
        const ym = dayjs(date).format('YYYYMM');
        return {label: `${date.getMonth() + 1}`, value: ym};
    });

    months.unshift({ label: '全部', value: undefined });

    const onOptionChange = (value) => {
        setYearMonth(value);
        onChange?.(value);
    }

    return (
        <div style={{ marginBottom: 10}}>
            <div>按月查看{yearMonth !== undefined && <span>(已结算)</span>}</div>
            <Radio.Group options={months} optionType='button' onChange={(e) => onOptionChange?.(e.target.value)} />月
        </div>
    )
};